const initialState = {
  loading: true,
  empty: true,
  id: null,
  items: [],
  removedItems: [],
  subtotal: 0,
  selectedEngraving: null,
  engraving: {
    active: false,
    msg: {
      line1: '',
      line2: '',
      line3: '',
      line4: ''
    }
  },
  bundle: {
    active: false,
    data: {}
  }
}

export default initialState
